import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import LogoWithText from "../shared/svgIcons/LogoWithText";
import { useGetConfirmEmailByHashQuery } from "../../api/invitedAdmins";
import "./style.confirmation.scss";
import { TiWarning } from "react-icons/ti";
import bg from "../../images/cover.png";
import { CircularProgress } from "@mui/material";

import { AiFillCheckCircle } from "react-icons/ai";

const Confirmation = () => {
  const [isConfirmError, setIsConfirmError] = useState(false);
  const [username, setUsername] = useState("");
  const { hash } = useParams();

  const { data, error, isLoading } = useGetConfirmEmailByHashQuery({ hash }, {
    skip: !hash,
  });

  useEffect(() => {
    if (!isLoading) {
      if (error) {
        setIsConfirmError(error.data && error.data.message);
      } else {
        setUsername(data.email);
      }
    }
  }, [data, error, isLoading]);

  return (
    <div className="screen screen-flex screen_confirmation">
      <div className="container container_contain-center loginmain">
        <img src={bg} alt="" className="confirmation-bg" />

        <div className="container container_confirmation">
          <div className="confirmation-logo-wrapper">
            <LogoWithText className="confirmation-logo" />
          </div>

          <div className="confirmation">
            {isLoading ? (
              <React.Fragment>
                <div className="confirmation__text">please wait</div>
                <CircularProgress className="loading-progress" />
              </React.Fragment>
            ) : (
              <React.Fragment>
                {isConfirmError ? (
                  <React.Fragment>
                    <div className="confirmation__icon-holder">
                      <TiWarning className="confirmation__icon confirmation__icon_error" />
                    </div>
                    <div className="confirmation__text">
                      While confirmation occurred error:
                    </div>
                    <div className="confirmation__text">{isConfirmError}</div>
                    <br />
                    <a href="bettertrucks://">back to shift</a>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="confirmation__icon-holder">
                      <AiFillCheckCircle className="confirmation__icon" />
                    </div>
                    <div className="confirmation__text">
                      Your email {username} is confirmed
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
